














import { computed, defineComponent } from "@vue/composition-api";
import { CreditCardAssignment, CreditCardType } from "@scrile/api-provider/dist/api/CreditCardAssignmentsProvider";

export default defineComponent({
  name: "CardItem",
  props: {
    card: {
      type: Object as () => CreditCardAssignment,
      required: true,
    },
  },
  setup(props) {
    const image = computed(() => (props.card.type !== CreditCardType.OTHER ? props.card.type : ""));
    return {
      image,
    };
  },
});
